angular.module('qkr').controller('finance1Controller', finance1Controller);
function finance1Controller($uibModal, messageService, gettextCatalog, lookupDataUploadService, lookupFinance1Response,
                            beneficiaryCustomFields, subscriptionService, APP_CONSTANT) {
    const vm = this;
    vm.loading = false;
    vm.profileDataUploadForm = {};
    vm.file = {};
    vm.fileSelected = null;
    vm.orderProp = 'stLastName';
    vm.orderReverse = false;
    vm.lookupFinance1List = [];
    vm.nonMatchedLookupFinance1List = [];
    vm.matchedLookupFinance1List = [];
    vm.totalUploadedFinance1 = '';
    vm.latestUploadDate = '';
    vm.reason = {};
    vm.yearWarningMessage = beneficiaryCustomFields.find(field => field.fieldName === 'Year') ?
        '' : `'${gettextCatalog.getString('Year')}' ${gettextCatalog.getString('is not configured Student Details')}`;
    vm.referenceWarningMessage = '';
    vm.errorDetails = '';



    function prepareData(lookupFinance1InfoResponse) {
        vm.lookupFinance1List = lookupFinance1InfoResponse.lookupFinances.map(lookupDataUploadService.addFilterKey);
        vm.nonMatchedLookupFinance1List = lookupFinance1InfoResponse.nonMatchedLookupFinances.map(lookupDataUploadService.addFilterKey);
        vm.matchedLookupFinance1List = lookupFinance1InfoResponse.matchedLookupFinances.map(lookupDataUploadService.addFilterKey);
        vm.totalUploadedFinance1 = lookupFinance1InfoResponse.numLastUploadedFinance1;
        vm.latestUploadDate = lookupFinance1InfoResponse.lastUploadedDate;
        subscriptionService.executeAction(APP_CONSTANT.SubscriptionService.ACCOUNTANCY_FINANCE_NON_MATCHES_COUNT,
            countUndefinedFinance1FamilyNumbers(vm.nonMatchedLookupFinance1List));
    }

    function init() {
        prepareData(lookupFinance1Response);
    }

    function loadFinance1Data() {
        lookupDataUploadService.loadLookupFinance1Info().then((response) => {
            prepareData(response);
    }).catch(reason => {
            messageService.error(gettextCatalog.getString('Load finance 1 data failed'));
    });
    }
    vm.unknownLookupFinance1Config = () => {
        lookupDataUploadService.getUnknownLookupFinance1Config().then((response) => {
            $uibModal.open({
                template: require('../../templates/accountancy/finance1/unknownFinance1EmailConfig.html'),
                controller: 'unknownFinance1EmailConfigController as vm',
                windowClass: 'fade modal-huge',
                backdrop: 'static',
                resolve: {
                    data() {
                        return response.data;
                    }
                }
            });
        }).catch(reason => {
            messageService.error(gettextCatalog.getString('UnknownFinance1EmailConfig failed'));
        });
    };

    vm.uploadLookupFinance1Record = (file) => {
        if (!file) {
            return;
        }
        vm.fileSelected = file;
        vm.loading = true;
        lookupDataUploadService.uploadLookupFinance1Record(vm.fileSelected).then((response) => {
            if (response.lastUploadedDate === vm.latestUploadDate) {
                vm.uploadMessage = 'There were no records updated or created in the last file uploaded';
            }
            vm.totalUploadedFinance1 = response.numLastUploadedFinance1;
            vm.latestUploadDate = response.lastUploadedDate;
            vm.errorDetails = '';
            messageService.success(gettextCatalog.getString('File uploaded successfully'));
            vm.loading = false;
            loadFinance1Data();
        }).catch(reason => {
            if (reason.data.exception){
                vm.errorDetails =  reason.data.exception;
            }
            messageService.error(gettextCatalog.getString('File upload failed'));
            vm.loading = false;
        });
    };


    vm.sortBy = (colName) => {
        if (vm.orderProp === colName) {
            vm.orderReverse = !vm.orderReverse;
        } else {
            vm.orderProp = colName;
            vm.orderReverse = false;
        }
    };

    vm.sortIcon = (colName) => {
        if (colName === vm.orderProp) {
            return vm.orderReverse
        } else {
            return null;
        }
    };



    vm.updateLookupFinance1 = (lookupFinance1) => {
        lookupDataUploadService.updateLookupFinance1(lookupFinance1).then((response) => {
            messageService.success(gettextCatalog.getString('Lookup finance 1 updated'));
        loadFinance1Data();
    }).catch(reason => {
        if (reason.data.exception){
            vm.errorDetails = reason.data.exception;
        }
        messageService.error(gettextCatalog.getString('Update failed'));
    });
    };

    vm.hideLookupFinance1 = (lookupFinance1) => {
        lookupDataUploadService.hideLookupFinance1(lookupFinance1).then((response) => {
            messageService.success(gettextCatalog.getString('Hide lookup finance 1'));
        loadFinance1Data();
    }).catch(reason => {
        if (reason.data.exception){
            vm.errorDetails = reason.data.exception;
        }
        messageService.error(gettextCatalog.getString('Hide lookup finance 1 failed'));
    });
    };

    vm.unHideLookupFinance1 = (lookupFinance1) => {
        lookupDataUploadService.unHideLookupFinance1(lookupFinance1).then((response) => {
            messageService.success(gettextCatalog.getString('Unhide lookup finance 1'));
        loadFinance1Data();
    }).catch(reason => {
        if (reason.data.exception) {
            vm.errorDetails =  reason.data.exception;
        }
        messageService.error(gettextCatalog.getString('Unhide lookup finance 1 failed'));
    });
    };

    vm.showErrorDetails = (errorDetails) => {
        $uibModal.open({
            template: require('../../templates/accountancy/uploadErrorDetails.html'),
            controller: 'errorUploadLookupBeneficiaryController as vm',
            windowClass: 'fade modal-huge',
            backdrop: 'static',
            resolve: {
                data() {
                    return errorDetails;
                }
            }
        });
    };

    function countUndefinedFinance1FamilyNumbers(undefinedFinance1FamilyNumbers) {
        return undefinedFinance1FamilyNumbers.filter(f => !f.hidden).length;
    }
    init();
}



// WEBPACK FOOTER //
// ./src/finance1/controllers/finance1.controller.js